import '../../client/index.js';
import { wrapErrorManager } from '../../utils/error-manager.js';
import { transformCrmCustomerMeResponse, transformCrmCustomerMeAddressesShippingResponse, transformCrmCustomerMeAddressesBillingResponse, transformCrmCustomerMeAddressesListResponse, transformCrmCustomerMeAddressRequest, transformCrmCustomerMeSalesAgentsResponse, transformCrmCustomerMeQuotesResponse, transformCrmCustomerMeQuoteResponse, transformCrmCustomerMeQuoteTokenResponse } from './transformers.js';
import defaultClient from 'axios';

const getCrmCustomerMe = async ({ client , controller  } = {})=>await client.get(`V1/crm/customer/me`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCrmCustomerMeResponse)
        ]
    });
getCrmCustomerMe.key = 'getCrmCustomerMe';
const getCrmCustomerMeNewsletter = async ({ client , controller  } = {})=>await client.get(`V1/crm/customer/me/newsletter`, {
        signal: controller?.signal
    });
getCrmCustomerMeNewsletter.key = 'getCrmCustomerMeNewsletter';
const getCrmCustomerMeAddressesShipping = async ({ client , controller  } = {})=>await client.get(`V1/crm/customer/me/addresses/shipping`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCrmCustomerMeAddressesShippingResponse)
        ]
    });
getCrmCustomerMeAddressesShipping.key = 'getCrmCustomerMeAddressesShipping';
const getCrmCustomerMeAddressesBilling = async ({ client , controller  })=>await client.get(`V1/crm/customer/me/addresses/billing`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCrmCustomerMeAddressesBillingResponse)
        ]
    });
getCrmCustomerMeAddressesBilling.key = 'getCrmCustomerMeAddressesBilling';
const getCrmCustomerMeAddressesList = async ({ client , controller  })=>await client.get(`V1/crm/customer/me/addresses/list`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCrmCustomerMeAddressesListResponse)
        ]
    });
getCrmCustomerMeAddressesList.key = 'getCrmCustomerMeAddressesList';
const postCrmCustomerMeAddress = async ({ client , controller , address , defaultShipping , defaultBilling  } = {})=>client.post(`V1/crm/customer/me/address`, {
        address,
        defaultShipping,
        defaultBilling
    }, {
        signal: controller?.signal,
        transformRequest: [
            transformCrmCustomerMeAddressRequest,
            ...(client || defaultClient).defaults.transformRequest
        ]
    });
postCrmCustomerMeAddress.key = 'postCrmCustomerMeAddress';
const deleteCrmCustomerMeAddress = async ({ client , controller , id  } = {})=>await client.delete(`V1/crm/customer/me/address/${id}`, {
        signal: controller?.signal
    });
deleteCrmCustomerMeAddress.key = 'deleteCrmCustomerMeAddress';
const postCrmCustomerMeAddressesBilling = async ({ client , controller , id  } = {})=>await client.post(`V1/crm/customer/me/addresses/billing`, {
        address_id: id
    }, {
        signal: controller?.signal
    });
postCrmCustomerMeAddressesBilling.key = 'postCrmCustomerMeAddressesBilling';
const postCrmCustomerMeAddressesShipping = async ({ client , controller , id  } = {})=>await client.post(`V1/crm/customer/me/addresses/shipping`, {
        address_id: id
    }, {
        signal: controller?.signal
    });
postCrmCustomerMeAddressesShipping.key = 'postCrmCustomerMeAddressesShipping';
const postCrmCustomerMeNewsletterSubscribe = async ({ client , controller , source  } = {})=>await client.post(`V1/crm/customer/me/newsletter/subscribe`, {
        source
    }, {
        signal: controller?.signal
    });
postCrmCustomerMeNewsletterSubscribe.key = 'postCrmCustomerMeNewsletterSubscribe';
const postCrmCustomerMeNewsletterUnsubscribe = async ({ client , controller , source  } = {})=>await client.post(`V1/crm/customer/me/newsletter/unsubscribe`, {
        source
    }, {
        signal: controller?.signal
    });
postCrmCustomerMeNewsletterUnsubscribe.key = 'postCrmCustomerMeNewsletterUnsubscribe';
const patchCrmCustomerMePassword = async ({ client , controller , currentPassword , newPassword  })=>await client.patch(`V1/crm/customer/me/password`, {
        currentPassword,
        newPassword
    }, {
        signal: controller?.signal
    });
patchCrmCustomerMePassword.key = 'patchCrmCustomerMePassword';
const patchCrmCustomerMe = async ({ client , controller , dob , firstname , lastname , email , gender , taxvat , attributes ={}  })=>await client.patch(`V1/crm/customer/me`, {
        dob,
        firstname,
        lastname,
        email,
        gender: gender === 'man' ? 1 : gender === 'woman' ? 2 : 0,
        taxvat,
        additional_info: attributes
    }, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCrmCustomerMeResponse)
        ]
    });
patchCrmCustomerMe.key = 'patchCrmCustomerMe';
const getCrmCustomerMeSalesAgents = async ({ client , controller  })=>await client.get(`V1/crm/customer/me/salesagents`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCrmCustomerMeSalesAgentsResponse)
        ]
    });
getCrmCustomerMeSalesAgents.key = 'getCrmCustomerMeSalesAgents';
const getCrmCustomerMeQuotes = async ({ client , controller , offset =0 , limit =10000 , order =[]  } = {})=>await client.get(`/V1/crm/customer/me/quotes`, {
        signal: controller?.signal,
        params: {
            filter: {
                offset,
                limit,
                order
            }
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCrmCustomerMeQuotesResponse)
        ]
    });
getCrmCustomerMeQuotes.key = 'getCrmCustomerMeQuotes';
const getCrmCustomerMeQuote = async ({ client , controller , id  } = {})=>await client.get(`/V1/crm/customer/me/quotes/${id}`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCrmCustomerMeQuoteResponse)
        ]
    });
getCrmCustomerMeQuote.key = 'getCrmCustomerMeQuote';
const getCrmCustomerMeQuoteToken = async ({ client , controller , token  } = {})=>await client.get(`/V1/crm/pos/quote/${token}`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCrmCustomerMeQuoteTokenResponse)
        ]
    });
getCrmCustomerMeQuoteToken.key = 'getCrmCustomerMeQuoteToken';
const postCrmCustomerMeQuoteAddToCart = async ({ client , controller , token  } = {})=>await client.post(`V1/crm/pos/quote/addtocart`, {
        quoteToken: token
    }, {
        signal: controller?.signal
    });
postCrmCustomerMeQuoteAddToCart.key = 'postCrmCustomerMeQuoteAddToCart';

export { deleteCrmCustomerMeAddress, getCrmCustomerMe, getCrmCustomerMeAddressesBilling, getCrmCustomerMeAddressesList, getCrmCustomerMeAddressesShipping, getCrmCustomerMeNewsletter, getCrmCustomerMeQuote, getCrmCustomerMeQuoteToken, getCrmCustomerMeQuotes, getCrmCustomerMeSalesAgents, patchCrmCustomerMe, patchCrmCustomerMePassword, postCrmCustomerMeAddress, postCrmCustomerMeAddressesBilling, postCrmCustomerMeAddressesShipping, postCrmCustomerMeNewsletterSubscribe, postCrmCustomerMeNewsletterUnsubscribe, postCrmCustomerMeQuoteAddToCart };
